export default __webpack_public_path__ + "static/media/gilad_newman.d989a79a.jpg";